import dayjs from "dayjs";
import { Link } from "react-router";
import { useState } from "react";
import { api } from "../common/api";
import PdfViewer from "../common/PdfViewer";
import { date2locale } from "../common/common";
import SimpleTablePage from "../common/SimpleTablePage";
import { Button, DatePicker, Flex, Select, Tag } from "antd";
import DebounceSelect from "../common/DebounceSelect";
import { FileTextOutlined } from "@ant-design/icons";

const columns = (setOpenAppointment) => [
  {
    title: "ID",
    dataIndex: "id",
    sorter: true,
    key: "id",
    fixed: "left",
    width: 70,
    render: (id) => <Link to={"" + id}>{id}</Link>,
  },
  {
    title: "Data",
    key: "date",
    dataIndex: "date",
    sorter: true,
    ellipsis: true,
    width: 120,
    render: (date) => date2locale(date),
  },
  {
    title: "Categoria",
    key: "appointmentType",
    dataIndex: "appointmentType",
    render: (type) => type?.name,
    sorter: true,
    ellipsis: true,
    width: 150,
  },
  {
    title: "Dipendente",
    ellipsis: true,
    key: "employee",
    dataIndex: "employee",
    render: (employee) => employee?.fullName,
    sorter: true,
    width: 150,
  },
  {
    title: "Stato corso",
    key: "courseId",
    dataIndex: "courseId",
    ellipsis: true,
    width: 150,
    render: (courseId) => (
      <Tag variant={"outlined"} color={courseId ? "green" : "red"}>
        {courseId ? "Ok" : "Assente"}
      </Tag>
    ),
  },
  {
    title: "Documento",
    key: "document",
    render: (_, item) => (
      <Button
        size="small"
        icon={<FileTextOutlined />}
        onClick={(e) => {
          e.stopPropagation();
          setOpenAppointment(encodeURI(`/appointment/${item.id}/file`));
        }}
      />
    ),
  },
];

const entityFilter = (name, label, resource, getLabel) => ({
  name,
  label,
  readableValue: (value) => value && JSON.parse(value).label,
  formItem: {
    props: {
      getValueProps: (value) => ({ value: value && JSON.parse(value) }),
      normalize: (value) => value && JSON.stringify(value),
    },
    children: (
      <DebounceSelect
        allowClear
        minSize={0}
        fetchOptions={(query) =>
          api[resource]
            .list({ query, pageSize: 9999 })
            .then(({ data }) => data.map((item) => ({ label: getLabel(item), value: item.id })))
        }
      />
    ),
  },
});

const dateFilter = (name, label) => ({
  name,
  label,
  readableValue: date2locale,
  formItem: {
    props: {
      getValueProps: (value) => ({ value: value ? dayjs(value) : null }),
      normalize: (value) => value?.format("YYYY-MM-DD"),
    },
    children: <DatePicker format="DD-MM-YYYY" style={{ width: "100%" }} />,
  },
});

const filterItems = [
  entityFilter("employee", "Dipendente", "employee", (item) => item.fullName),
  entityFilter("appointmentType", "Categoria", "appointmentType", (item) => item.name),
  dateFilter("startDate", "Data dal"),
  dateFilter("endDate", "Data al"),
  {
    name: "hasCourse",
    label: "Stato corso",
    readableValue: (value) => (value === "true" ? "Ok" : "Assente"),
    formItem: {
      children: (
        <Select
          allowClear
          options={[
            { label: "Ok", value: "true" },
            { label: "Assente", value: "false" },
          ]}
        />
      ),
    },
  },
];

export default function Appointments() {
  const [openAppointment, setOpenAppointment] = useState();
  const fetch = (params) =>
    api.appointment.list({
      ...params,
      employee: params.employee ? JSON.parse(params.employee).value : undefined,
      appointmentType: params.appointmentType
        ? JSON.parse(params.appointmentType).value
        : undefined,
    });

  return (
    <Flex vertical gap={24}>
      <PdfViewer url={openAppointment} onClose={() => setOpenAppointment(null)} />
      <SimpleTablePage
        resource="appointment"
        title={"Nomine"}
        description={"Gestisci le nomine dei lavoratori"}
        columns={columns(setOpenAppointment)}
        filterItems={filterItems}
        fetchFunction={fetch}
      />
    </Flex>
  );
}
